import {DefaultInteraction} from "./interaction";
import * as THREE from "three";
import {TextGeometry} from "three/examples/jsm/geometries/TextGeometry";
import {FontLoader} from "three/examples/jsm/loaders/FontLoader";


export class ShowMessageHandler extends DefaultInteraction {

	cards = [];

	visibleCards = []

	font = null
	camera = null

	constructor(props) {
		super(props);
		this.camera = props.camera

		new FontLoader().load('/assets/fonts/helvetiker_regular.typeface.json', (font) => {
			this.font = font
		})
	}


	key() {
		return "show_message"
	}

	interact(interactionData, metadata, onSuccess, onError) {
		console.log(`Interaction::${this.key()} - Run`, interactionData, metadata)

		//TODO Get scene
		//TODO Trigger show of object from alphaID

		return true
	}

	onAdd(obj, interaction) {
		const card = this.createCard(
			interaction.data.title,
			interaction.data.message,
			{
				textColor: interaction.data.textColor,
				backgroundColor: interaction.data.backgroundColor,
			}
		)

		let box = new THREE.Box3().setFromObject(obj)
		let size = new THREE.Vector3()
		box.getSize(size)

		if (interaction.data.center_offset)
			card.position.set(interaction.data.center_offset[0], interaction.data.center_offset[1], interaction.data.center_offset[2])
		obj.userData.centerOffset = interaction.data.center_offset || card.position.clone()

		// card.position.set(0,box.max.y, 0)
		card.rotation.copy(obj.rotation)
		// card.translateZ(size.z / 2.0)

		obj.add(card)

		card.userData.originPosition = card.position.clone()
		card.userData.originRotation = obj.rotation.clone()

		// this.card[obj.userData.alphaID] = card
		this.cards = {
			...this.cards,
			[obj.userData.alphaID]: card
		}
	}


	onProximityExit(interactable) {
		this.cards[interactable.userData.alphaID].visible = false
	}

	onProximityEnter(interaction, interactable) {
		this.cards[interactable.userData.alphaID].visible = true
		this.visibleCards.push(interactable)
	}

	/**
	 * Called once per loop
	 *
	 * @param player
	 * @param interactions
	 */
	onUpdate(player, interactions) {
		if (this.visibleCards.length > 0)
			this._tidyVisibleCards(player, interactions)
	}

	/**
	 * Tidy cards around player & orientate towards the screen
	 * @param player
	 * @param interactions
	 * @private
	 */
	_tidyVisibleCards(player, interactions) {
		for (let i = 0; i < this.visibleCards.length; i++) {
			const interactable = this.visibleCards[i]
			const interaction = interactions[interactable.userData.alphaID]

			if (!this.inRange(player, interactable, interaction.proximity.activation_radius)) {
				this.cards[interactable.userData.alphaID].visible = false
				continue
			}

			const p = interactable.position
			const distance = this.camera.position.clone().sub(p); // Note: depending on the order of subtracting, you'll get either forward or backward direction
			const dn = distance.normalize()

			// this.cards[interactable.userData.alphaID].setRotationFromQuaternion( this.camera.quaternion )
			// this.cards[interactable.userData.alphaID].quaternion.copy( this.camera.quaternion );

			this.cards[interactable.userData.alphaID].lookAt(this.camera.position)
			this.cards[interactable.userData.alphaID].rotation.x = 0
			this.cards[interactable.userData.alphaID].rotation.z = 0

			if (interactable.userData.centerOffset) {
				this.cards[interactable.userData.alphaID].position.set(interactable.userData.centerOffset[0], interactable.userData.centerOffset[1], interactable.userData.centerOffset[2])
			} else
				this.cards[interactable.userData.alphaID].position.set(0, 0, 0)

			this.cards[interactable.userData.alphaID].translateOnAxis(dn, 1)

			if (distance.z < 0) {
				this.cards[interactable.userData.alphaID].rotateY(Math.PI);
			}
		}
	}

	createCard(title, description, customizations = {textColor: "#ff0000", backgroundColor: "#ffffff"}) {
		const group1 = this.createText(title, .05, customizations.textColor)
		const group2 = this.createText(description, .02, customizations.textColor)
		group2.mesh.position.y = -.1

		const group4 = new THREE.Group()

		group4.add(group1.mesh, group2.mesh)

		const height = (group1.box.max.y + group2.box.max.y) * 5
		const width = Math.max(group1.box.max.x, group2.box.max.x) * 1.2
		const geometry = new THREE.PlaneGeometry(width, height)
		const material = new THREE.MeshStandardMaterial({color: customizations.backgroundColor, side: THREE.DoubleSide, transparent: true, opacity: 0.60});
		const plane = new THREE.Mesh(geometry, material);

		plane.position.set(width / 2, -height / 3, 0)
		plane.position.y += (height / 100) * 3
		plane.position.x -= (width / 100) * 3

		group4.add(plane)

		group4.name = "card"
		group4.visible = false
		return group4
	}

	splitString(string, line = 35) {
		const stringArray = string.split(' ')
		let splitString = []

		for (let i = 0; i < stringArray.length; i++) {
			const word = stringArray[i]

			if (splitString.length > 0 && splitString[splitString.length - 1].length + word.length <= line) {
				splitString[splitString.length - 1] = `${splitString[splitString.length - 1]} ${word}`
				continue
			}

			splitString.push(word)
		}

		return splitString.join('\n')
	}

	createText(title, size, color) {
		title = this.splitString(title)

		const titleObj = new TextGeometry(title, {
			font: this.font,
			size: size,
			height: .001,
			curveSegments: 2,
		})

		titleObj.computeBoundingBox()
		const textMesh1 = new THREE.Mesh(titleObj, new THREE.MeshBasicMaterial({color: color}))

		return {
			box: titleObj.boundingBox,
			mesh: textMesh1
		}
	}
}